import { formateWithMoment } from '@/utilz';
import type { QuoteRate } from '@/views/screens/Quote';
import { Col, Row } from 'antd';

export const QuoteRatePanelHeader = ({ rate }: { rate: QuoteRate }) => {
  return (
    <>
      <Row gutter={10} className="flex-nowrap mb-12" justify="space-between">
        <Col>
          <p className="m-0 fw-600 f-16 color-dark">{rate.carrierName}</p>
        </Col>
      </Row>
      <Row gutter={10} className="flex-nowrap" justify="space-between">
        <Col sm={2}>
          <p className="m-0 fw-400 f-13 color-label">Cost</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.cost}</p>
        </Col>
        <Col sm={2}>
          <p className="m-0 fw-400 f-13 color-label">Currency Code</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.currencyCode}</p>
        </Col>
        <Col sm={3}>
          <p className="m-0 fw-400 f-12 color-label">Pricing Basis</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.pricingBasis}</p>
        </Col>
        <Col sm={3}>
          <p className="m-0 fw-400 f-12 color-label">Transit Days</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.transitDays}</p>
        </Col>
        <Col sm={3}>
          <p className="m-0 fw-400 f-12 color-label">Cargo Type</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.cargoType}</p>
        </Col>
        <Col sm={4}>
          <p className="m-0 fw-400 f-12 color-label">Service Description</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.serviceDescription}</p>
        </Col>
        <Col sm={3}>
          <p className="m-0 fw-400 f-12 color-label">Equipment Type</p>
          <p className="m-0 fw-500 f-13 color-dark">{rate.equipmentTypeDetail}</p>
        </Col>
        <Col sm={4}>
          <p className="m-0 fw-400 f-12 color-label">Created On</p>
          <p className="m-0 fw-500 f-13 color-dark">{formateWithMoment(rate.createdOn)}</p>
        </Col>
      </Row>
    </>
  );
};
